module.exports = __webpack_public_path__ + "img/PT3010.9dcf25ec.png";